import React from "react";

export const Search = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1554_4048)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.59292 14.2419C4.59292 11.0039 5.49651 8.79697 6.89615 7.39736C8.29576 5.99775 10.5027 5.09413 13.7406 5.09413C16.9786 5.09413 19.1855 5.99775 20.5851 7.39736C21.9847 8.79697 22.8883 11.0039 22.8883 14.2419C22.8883 17.4798 21.9847 19.6867 20.5851 21.0863C19.1855 22.486 16.9786 23.3897 13.7406 23.3897C10.5027 23.3897 8.29576 22.486 6.89615 21.0863C5.49651 19.6867 4.59292 17.4798 4.59292 14.2419ZM13.7406 0.522705C9.6612 0.522705 6.15139 1.67712 3.66364 4.16488C1.1759 6.65263 0.0214844 10.1624 0.0214844 14.2419C0.0214844 18.3213 1.1759 21.8311 3.66364 24.3188C6.15139 26.8066 9.6612 27.9611 13.7406 27.9611C16.9235 27.9611 19.7596 27.2582 22.034 25.7677L28.0623 31.7965C28.9551 32.6891 30.4021 32.6891 31.2949 31.7965C32.1875 30.9039 32.1875 29.4566 31.2949 28.5641L25.2666 22.5353C26.7571 20.2609 27.4597 17.4247 27.4597 14.2419C27.4597 10.1624 26.3054 6.65263 23.8177 4.16488C21.3299 1.67712 17.8201 0.522705 13.7406 0.522705Z"
          fill="#6C3BC7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1554_4048">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
